import { Col, Row } from "react-bootstrap"
import React from "react"
import { CompetitionPageHeader } from "@components/Competition/CompetitionPageHeader/CompetitionPageHeader"
import { SeasonAPI } from "../../../../../src/apis/SeasonAPI"
import { CompetitionAPI } from "../../../../../src/apis/CompetitionAPI"
import { getNavigationProps } from "@components/Navigation/getNavigationProps"
import { RSS, SEO } from "../../../../../src/types/next.js"
import InferNextPropsType from "infer-next-props-type"
import { ParsedUrlQuery } from "querystring"
import { GetStaticPropsContext } from "next"
import * as NextConstants from "constants/next"
import { CompetitionSeasonAPI } from "../../../../../src/apis/CompetitionSeasonAPI"
import { CompetitionConstants } from "../../../../../src/constants/competitions"
import { CompetitionSeasonPlayerStandings } from "@components/Competition/CompetitionSeasonPlayerStandings/CompetitionSeasonPlayerStandings"
import { getCompetitionCanonicalData } from "../../../../../src/utils/competition"
import { NewTitleBanner } from "@components/Banners/NewTitleBanner"
import homePlayerStats from "@assets/images/title-banner/home-player-stats.png"
import { BookmakerBonusAPI } from "apis/BookmakerBonusAPI"
import { simplifyBookmakerBonus } from "../../../../../src/utils/bookmakerBonus"

export default function CompetitionPage({
  competitionCalciocomSlug,
  seasonCalciocomSlug,
  seasons,
  playerParameterStandings,
  headerTitle,
  competitionDetail,
}: InferNextPropsType<typeof getStaticProps>) {
  return (
    <>
      <Row className={"marginZero new-statistiche-giocatori"}>
        <Col md={12} className={"paddingZero"}>
          <div id="hs-content" className={"hs-border-div paddingZero"}>
            <div className="new-statistiche-giocatori">
              <CompetitionPageHeader
                selected="statistiche-giocatori"
                competitionCalciocomSlug={competitionCalciocomSlug}
                competition={competitionDetail}
              />
              <div className="statistiche-giocatori-container">
                <NewTitleBanner title={headerTitle === undefined ? "Statistiche giocatori" : headerTitle} />
                <div className="stat-giocatori-wrapper">
                  <CompetitionSeasonPlayerStandings
                    competitionCalciocomSlug={competitionCalciocomSlug}
                    seasonCalciocomSlug={seasonCalciocomSlug}
                    playerStandings={playerParameterStandings}
                    headerTitle={headerTitle}
                    seasons={seasons}
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

export interface IParams extends ParsedUrlQuery {
  competitionCalciocomSlug: string
  seasonCalciocomSlug: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>, index = false) {
  const { competitionCalciocomSlug, seasonCalciocomSlug } = context.params!

  try {
    const [competitionIds, seasonIds] = await Promise.all([
      CompetitionAPI.getCompetitionIds(competitionCalciocomSlug),
      SeasonAPI.getSeasonIds(seasonCalciocomSlug),
    ])
    const competition = await CompetitionAPI.getCompetition(competitionIds.id)

    const seasons = await SeasonAPI.getSeasonsByCompetitionId(competitionIds.id)
    const season = seasons.find((season) => season.id === seasonIds.id)!

    const competitionSeasonId = await CompetitionSeasonAPI.getIdByCompetitionIdAndSeasonId(competition.id, season.id)
    const playerParameterStandings = await CompetitionSeasonAPI.getPlayerParameterStandings(competitionSeasonId)

    const competitionDetail = await CompetitionAPI.getLastSeasonCompetitionDetails(competitionIds.id)

    const title = `Classifica Giocatori ${competition.name} - ${season?.name}`

    const seo: SEO = {
      title: title,
      description: `Controlla le classifiche dei giocatori di ${competition.name} della stagione ${season?.name} e scopri i migliori marcatori del momento su Calcio.com`,
      keywords: [`${competition.name}`, `${season?.name}`, "calcio", "Classifica", "Risultati"],
      ...(await getCompetitionCanonicalData(
        competition,
        season,
        null,
        null,
        `/campionato/${competitionCalciocomSlug}/stagione/${seasonCalciocomSlug}/statistiche-giocatori`,
      )),
      canonicals: [`/campionato/${competitionCalciocomSlug}/statistiche-giocatori`],
      index: index,
    }

    let rss: RSS | null = null
    if (CompetitionConstants.TOP_COMPETITIONS_IDS.includes(competition.id)) {
      rss = {
        competitionCalcioComSlug: competitionCalciocomSlug,
      }
    }

    return {
      props: {
        competitionCalciocomSlug: competitionCalciocomSlug,
        seasonCalciocomSlug: seasonCalciocomSlug,
        seasons,
        playerParameterStandings,
        competitionDetail,
        navigationProps: await getNavigationProps(competitionIds.id),
        title,
        seo,
        rss,
        headerTitle: `Statistiche giocatori ${competition.name} ${season?.name}`,
      },
      revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
